import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const EndOfTenancyCleaningPage = () => {
  const pageData = {
    pageTitle: "End of Tenancy Cleaning Cardiff | Move Out Cleaning | NeatWave",
    metaDescription: "End of tenancy and move out cleaning in Cardiff, Barry and Penarth to landlord and letting agent checklists. From £120, with a 48-hour re-clean policy. Request a free quote.",
    quoteService: "End of Tenancy",
    heroImageAlt: "Before and after end of tenancy bathroom clean in Cardiff",
    
    heroTitle: "End of Tenancy Cleaning in Cardiff",
    heroSubtitle: "Thorough move-out cleaning to landlord and letting agent checklists, across Cardiff, Barry and Penarth.",
    heroImage: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/c5ef6d33d0a85024_Screenshot_20260329_024533_ChatGPT.webp",
    secondaryImage: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/305227b6743b3627_Screenshot_20260325_012051_Google.webp",
    secondaryImageAlt: "End of Tenancy Kitchen Cleaning Before and After",
    
    serviceDescription: (
      <>
        <p className="mb-4">
          Moving out of a rental property in Cardiff? Our professional end of tenancy cleaning service ensures your property is left spotless, meeting the highest standards expected by landlords and letting agents throughout Wales.
        </p>
        <p className="mb-4">
          We understand how stressful moving can be. That's why our comprehensive deep clean covers every corner of your property, from the kitchen and bathrooms to carpets and windows. Our experienced, DBS-checked cleaners follow a detailed checklist to ensure nothing is missed.
        </p>
        <p className="mb-4">
          Covering Cardiff, Barry and Penarth, we help tenants and landlords hand properties back in excellent condition. Landlords and letting agents with several properties can also ask about our <a href="/landlord-letting-agent-cleaning-cardiff">contract cleaning for landlords</a>. All our cleaners are fully insured and trained to meet strict letting agent requirements.
        </p>
      </>
    ),
    
    whatIncluded: [
      {
        title: "Kitchen Deep Clean",
        description: "All appliances inside & out (oven, fridge, dishwasher), cupboards, worktops, tiles, sink & taps"
      },
      {
        title: "Bathroom Sanitization",
        description: "Toilet, bath, shower, tiles, mirrors, sink, taps - descaled and sanitized"
      },
      {
        title: "Living Areas",
        description: "Dusting all surfaces, skirting boards, light fixtures, switches, windowsills, radiators"
      },
      {
        title: "Bedrooms",
        description: "Inside wardrobes, drawers, under beds, all surfaces, mirrors, doors"
      },
      {
        title: "Windows & Doors",
        description: "Interior window cleaning, door frames, handles, glass panels"
      },
      {
        title: "Floors",
        description: "Vacuum and mop all floors, under furniture where accessible"
      }
    ],
    
    pricingInfo: {
      duration: "4-9 hours",
      price: "From £120",
      note: "Final price depends on property size and condition. 1-bed flats from £120, 2-bed from £150, 3-bed from £180. Get an accurate quote using our calculator."
    },
    
    faqs: [
      {
        q: "Will this cleaning help with my deposit?",
        a: "A professional clean to an agency-standard checklist gives you the best chance of a smooth checkout. We cannot guarantee your deposit, because deposit decisions also depend on damage, wear and tear, and other tenancy terms that are outside our control."
      },
      {
        q: "How long does end of tenancy cleaning take?",
        a: "It depends on property size and condition. A 1-bed flat typically takes 4-5 hours, 2-bed property 5-6 hours, 3-bed 6-7 hours, and larger properties 7-9 hours. We'll provide an accurate time estimate when you book."
      },
      {
        q: "Do I need to be present during the clean?",
        a: "No, you don't need to be there. Many clients leave keys with us or arrange key collection with their letting agent. All our cleaners are DBS-checked and fully insured for your peace of mind."
      },
      {
        q: "What if the landlord isn't satisfied?",
        a: "We offer a 48-hour re-clean policy. If your landlord or letting agent reports a cleaning issue within 48 hours of our clean, we will return to re-clean the affected areas free of charge, provided: the area was included in the original booking, the property has not been re-occupied, used or altered since our clean, and you send us the details (photos help) within the 48 hours. The policy covers cleaning only, not damage, wear and tear, or items outside the booked scope."
      },
      {
        q: "When should I book end of tenancy cleaning?",
        a: "Book as soon as you have your move-out date confirmed. We recommend booking 1-2 weeks in advance, especially during busy periods (end of month, university terms). Last-minute bookings may be available - just call us."
      }
    ],
    
    testimonial: {
      text: "We had Neatwave carry out all of our end of tenancy cleans when our student tenancies swapped over, they completed around 60 oven cleans for us and they were fab, very professional and reasonably priced, would definitely recommend.",
      author: "Charlie Redding, Pinnacle Property Management - Google review"
    },
    
    relatedServices: [
      {
        title: "Deep Cleaning",
        description: "Comprehensive deep clean for homes needing extra attention",
        url: "/deep-cleaning-cardiff"
      },
      {
        title: "Regular Domestic Cleaning",
        description: "Weekly or fortnightly cleaning for your new home",
        url: "/domestic-cleaning-cardiff"
      },
      {
        title: "Oven Cleaning",
        description: "Specialist oven cleaning to restore shine",
        url: "/oven-cleaning-cardiff"
      }
    ]
  };

  return <ServicePageTemplate {...pageData} />;
};

export default EndOfTenancyCleaningPage;
